
import _ from 'lodash'
import '../../../css/svdreact.css'
import '../../../css/cm.css'
import Terrain from '../../terrain/Terrain'
import CardTerrain from '../../terrain/CardTerrain'
import TerrainGallery from '../../terrain/TerrainGallery'
import { Button as SVAButton } from 'antd';
import { SV_SOJ_ORCMOCK_ADDRESS, CARN_URL, PROMO_SOURCE_TYPE, IM_AWS, IM_SVAMCOS, COSMOS_IM_URL,IM_PSURLS_AWS, IM_CDN,CDN_PROM_ADDRESS } from '../../../constants'
import GlassTerrain from '../../terrain/GlassTerrain'
import { noop } from 'react-bootstrap-typeahead/types/utils'
import { COSMOS_SEGMENTS_DETAIL } from '../../../constants'
import { sojAndImagesSojourn } from '../../../redux/svractions/sojsearchActions'
const React = require('react')
class CityTerrainContainer extends React.Component {

  constructor(props) {
    super(props)
    let me = this

    this.getChildContainers = this.getChildContainers.bind(me)
    this.getChildContainersR1 = this.getChildContainersR1.bind(me)
    this.getChildContainersCruise = this.getChildContainersCruise.bind(me)
    this.getCgBody = this.getCgBody.bind(me)
    this.getCgBodyCruise = this.getCgBodyCruise.bind(me)
    this.getCgBodyR1 = this.getCgBodyR1.bind(me)
  }
  getChildContainersR1() {
    let my_data_promolist = [{
      "org": "San Francsico",
      "dst": "Athens, Greece",
      "img": "promo10.png",
      "urlImg": "url(http://localhost:8086/images/promo10.png)",
      "price": "$630",
      "type": "oneway",
      "date": "02/13/2026"

    }, {
      "org": "San Francsico",
      "dst": "Athens, GR",
      "img": "promo9.png",
      "urlImg": "url(http://localhost:8086/images/promo9.png)",
      "price": "$830",
      "type": "oneway",
      "date": "02/13/2026"
    }, {
      "org": "San Francsico",
      "dst": "New Delhi, IND",
      "img": "promo7.png",
      "urlImg": "url(http://localhost:8086/images/promo7.png)",
      "price": "$1030",
      "type": "oneway",
      "date": "02/13/2026"
    }, {
      "org": "San Francsico",
      "dst": "Madrid, SP",
      "img": "promo6.png",
      "urlImg": "url(http://localhost:8086/images/promo6.png)",
      "price": "$780",
      "type": "oneway",
      "date": "02/13/2026"

    }]
    /*
    
    `${SV_SOJ_ORCMOCK_ADDRESS}/images/${o.img}`
    <img src={`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`} alt="Carpet Grass" />
                                             
    */
    let imCruise = `url(${SV_SOJ_ORCMOCK_ADDRESS}/images/promo1.png)`

    const l = 'http://localhost:8086/images'
    const l2 = 'http://localhost:8086/images/soj3.jpg'
    return (

      <div id="features" className="features section">

       

        <div className="row">
          <div className="col-lg-12">
            <div className="svfeatures-content">
              <div className="c-container-pic">
                {
                  my_data_promolist.map(o => {
                    let soj = o
                   // let im = `url(${SV_SOJ_ORCMOCK_ADDRESS}/images/${o.img})`
                    let im = `url(${SV_SOJ_ORCMOCK_ADDRESS}/images/${o.img})`
                    
                    //convet keys of o to uppercase
                    console.log('sv***soj**im Flu1')
                    console.log(soj)
                    console.log(im)


                    return (


                      <div className="c-container-cabinet col-lg-3">
                        <div className="c-box-shelf">
                          <div className=" c-box-pic">
                            <div style={{
                              "backgroundImage": im
                            }} className="svfeatures-item first-feature wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                              <div className="first-number number">
                                <h6 style={{ visibility: "hidden" }}>Fly For {soj.price}</h6>
                              </div>
                              <div className="icon"></div>
                              <h4 className="c-box-pic-text"><SVAButton style={{ fontSize: '12px', padding: '5px', color: '#ffffff', backgroundColor: '#ee2e2ef2' }} type="primary" shape="round" size="{size}" >Fly To {soj.dst} </SVAButton></h4>
                              <div className="line-dec"></div>
                              <p style={{ height: "200px" }}>
                              </p>
                            </div>
                          </div>


                        </div>
                        <div className='c-box-shelf'>

                          <div className="box-promo-outer">
                            <span className="t-left">
                              <p className="sd-check" className="txt-price-type" ><text>From {soj.org}</text></p>

                            </span>
                            <span className="t-right">

                              <p className="sd-check" className="txt-price-val"><text> Price {soj.price} </text></p>
                            </span>

                          </div>
                        </div>



                      </div>










                    )


                  })
                }

              </div>
            </div>
          </div>
        </div>
        
        
      </div>
    )
  }
  
  getChildContainersCruise() {
    let my_data_promolist = [{
      "org": "San Francsico",
      "dst": "Athens, Greece",
      "img": "crpromo1.png",
      "urlImg": "url(http://localhost:8086/images/crpromo1.png)",
      "price": "$630",
      "type": "oneway",
      "date": "02/13/2026"

    }, {
      "org": "San Francsico",
      "dst": "Athens, GR",
      "img": "crpromo2.png",
      "urlImg": "url(http://localhost:8086/images/crpromo2.png)",
      "price": "$830",
      "type": "oneway",
      "date": "02/13/2026"
    }, {
      "org": "San Francsico",
      "dst": "New Delhi, IND",
      "img": "crpromo3.png",
      "urlImg": "url(http://localhost:8086/images/crpromo3.png)",
      "price": "$1030",
      "type": "oneway",
      "date": "02/13/2026"
   
    }]
    /*
    
    `${SV_SOJ_ORCMOCK_ADDRESS}/images/${o.img}`
    <img src={`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`} alt="Carpet Grass" />
                                             
    */
    let imCruise = `${SV_SOJ_ORCMOCK_ADDRESS}/images/promo1.png`

    const l = 'http://localhost:8086/images'
    const l2 = 'http://localhost:8086/images/soj3.jpg'
    return (

      <div id="features" className="features section">

       

        <div className="row">
          <div className="col-lg-12">
            <div className="svfeatures-content"  style={{height:"800px"}}>
              <div className="c-container-pic">
                {
                  my_data_promolist.map(o => {
                    let soj = o
                    let im = ''
                    if (PROMO_SOURCE_TYPE == IM_AWS) {
                      im = `${COSMOS_IM_URL}SVRPROMO/${o.img}`
                      console.log('svmay29*******S3', im)
                    } else if(PROMO_SOURCE_TYPE == IM_PSURLS_AWS){
                      im = `${COSMOS_IM_URL}SVRPROMO/${o.img}`
                    } else if(PROMO_SOURCE_TYPE == IM_CDN){
                      im = `${CDN_PROM_ADDRESS}prom/${o.img}`

                    } else {

                      im = `${SV_SOJ_ORCMOCK_ADDRESS}/images/${o.img}`
                      console.log('svmay29*******86', im)
                    }

                    //convet keys of o to uppercase
                    console.log('sv***sojcruise jun4**')
                    console.log(soj)
                    console.log(im)


                    return (


                      <div className="c-container-cabinet col-lg-4">
                 
                      <div className="c-box-pic" 
                      
                      >
                        <img
                          src={im}
                          alt="Promo"
                          style={{
                            width: "100%",
                            height: "auto",
                            display: "block"
                          }}
                        />
                      
                    </div>
                  
                  </div>










                    )


                  })
                }

              </div>
            </div>
          </div>
        </div>
        
        
      </div>
    )
  }
  getChildContainersCruiseStatic() {
    let my_data_promolist = [{
      "org": "San Francsico",
      "dst": "Athens, Greece",
      "img": "promo10.png",
      "urlImg": "url(http://localhost:8086/images/promo10.png)",
      "price": "$630",
      "type": "oneway",
      "date": "02/13/2026"

    }, {
      "org": "San Francsico",
      "dst": "Athens, GR",
      "img": "promo9.png",
      "urlImg": "url(http://localhost:8086/images/promo9.png)",
      "price": "$830",
      "type": "oneway",
      "date": "02/13/2026"
    }, {
      "org": "San Francsico",
      "dst": "New Delhi, IND",
      "img": "promo7.png",
      "urlImg": "url(http://localhost:8086/images/promo7.png)",
      "price": "$1030",
      "type": "oneway",
      "date": "02/13/2026"
    }, {
      "org": "San Francsico",
      "dst": "Madrid, SP",
      "img": "promo6.png",
      "urlImg": "url(http://localhost:8086/images/promo6.png)",
      "price": "$780",
      "type": "oneway",
      "date": "02/13/2026"

    }]
    /*
    
    `${SV_SOJ_ORCMOCK_ADDRESS}/images/${o.img}`
    <img src={`${SV_SOJ_ORCMOCK_ADDRESS}/images/soj1.jpg`} alt="Carpet Grass" />
                                             
    */
    let imCruise = `url(${SV_SOJ_ORCMOCK_ADDRESS}/images/promo1.png)`

    const l = 'http://localhost:8086/images'
    const l2 = 'http://localhost:8086/images/soj3.jpg'
    return (

      <div id="features" className="features section">

       

        
        <div className="row">
          <div className="col-lg-12">
            <div className="svfeatures-content" style={{height:"800px"}}>
              <div className="c-container-pic">
                <div className="c-container-cabinet col-lg-4">
                 
                    <div className="c-box-pic" 
                    
                    >
                      <img
                        src="http://localhost:8086/images/crpromo1.png"
                        alt="Promo"
                        style={{
                          width: "100%",
                          height: "auto",
                          display: "block"
                        }}
                      />
                    
                  </div>
                
                </div>
               
                <div className="c-container-cabinet col-lg-4">
                 
                 <div className="c-box-pic" 
                 
                 >
                   <img
                     src="http://localhost:8086/images/crpromo2.png"
                     alt="Promo"
                     style={{
                       width: "100%",
                       height: "auto",
                       display: "block"
                     }}
                   />
                 
               </div>
             
           
                </div>
                <div className="c-container-cabinet col-lg-4">
                 
                    <div className="c-box-pic" 
                    
                    >
                      <img
                        src="http://localhost:8086/images/crpromo3.png"
                        alt="Promo"
                        style={{
                          width: "100%",
                          height: "auto",
                          display: "block"
                        }}
                      />
                    
                  </div>
                
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>
    )
  }
  getChildContainers() {
    let my_data_promolist = [{
      "org": "San Francsico",
      "dst": "Athens, Greece",
      "img": "promo1.png",
      "urlImg": "url(http://localhost:8086/images/promo1.png)",
      "price": "$630",
      "type": "oneway",
      "date": "02/13/2026"

    }, {
      "org": "San Francsico",
      "dst": "Athens, GR",
      "img": "promo2.png",
      "urlImg": "url(http://localhost:8086/images/promo2.png)",
      "price": "$830",
      "type": "oneway",
      "date": "02/13/2026"
    }, {
      "org": "San Francsico",
      "dst": "New Delhi, IND",
      "img": "promo3.png",
      "urlImg": "url(http://localhost:8086/images/promo3.png)",
      "price": "$1030",
      "type": "oneway",
      "date": "02/13/2026"
    }, {
      "org": "San Francsico",
      "dst": "Madrid, SP",
      "img": "promo4.png",
      "urlImg": "url(http://localhost:8086/images/promo4.png)",
      "price": "$780",
      "type": "oneway",
      "date": "02/13/2026"

    }]

    const l = 'http://localhost:8086/images'
    const l2 = 'http://localhost:8086/images/soj3.jpg'
    return (

      <div id="features" className="features section">

        <div className="row">
          <div className="col-lg-12">
            <div className="svfeatures-content">
              <div className="c-container-pic">
                {
                  my_data_promolist.map(o => {
                    let soj = o
                    let urlImgDyna = "url(" + SV_SOJ_ORCMOCK_ADDRESS + "/images/" + soj.img + ")"
                    let im = `url(${SV_SOJ_ORCMOCK_ADDRESS}/images/${o.img})`
                    /*
                    if (PROMO_SOURCE_TYPE == IM_AWS) {
                      im = `url(${SV_SOJ_ORCMOCK_ADDRESS}/images/${o.img})`
                      console.log('svmay29*******S3', im)
                    } else if(PROMO_SOURCE_TYPE == IM_PSURLS_AWS){
                      im = `url(${SV_SOJ_ORCMOCK_ADDRESS}/images/${o.img})`
                    } else if(PROMO_SOURCE_TYPE == IM_CDN){
                      im = `${CDN_PROM_ADDRESS}prom/${o.img}`

                    } else {

                      im = `url(${SV_SOJ_ORCMOCK_ADDRESS}/images/${o.img})`
                      console.log('svmay29*******86', im)
                    }
                    */
                    //convet keys of o to uppercase
                    console.log('sv***soj**')
                    console.log(im)
                    console.log(soj)

                    return (


                      <div className="c-container-cabinet col-lg-3">
                        <div className="c-box-shelf">
                          <div className=" c-box-pic">
                            <div style={{
                              "backgroundImage": im
                            }} className="svfeatures-item first-feature wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                              <div className="first-number number">
                                <h6 style={{ visibility: "hidden" }}>Fly For {soj.price}</h6>
                              </div>
                              <div className="icon"></div>
                              <h4 className="c-box-pic-text"><SVAButton style={{ fontSize: '12px', padding: '5px', color: '#ffffff', backgroundColor: '#ee2e2ef2' }} type="primary" shape="round" size="{size}" >Fly To {soj.dst} </SVAButton></h4>
                              <div className="line-dec"></div>
                              <p style={{ height: "200px" }}>
                              </p>
                            </div>
                          </div>


                        </div>
                        <div className='c-box-shelf'>

                          <div className="box-promo-outer">
                            <span className="t-left">
                              <p className="sd-check" className="txt-price-type" ><text>From {soj.org}} </text></p>

                            </span>
                            <span className="t-right">

                              <p className="sd-check" className="txt-price-val"><text> Price {soj.price} </text></p>
                            </span>

                          </div>
                        </div>



                      </div>










                    )


                  })
                }

              </div>
            </div>
          </div>
        </div>

      </div>
    )
  }
  getChildContainers_hw() {
    const l = 'http://localhost:8086/images'
    const l2 = 'http://localhost:8086/images/soj3.jpg'
    return (

      <div id="features" style={{ backgroundColor: "azure" }} className="features section">

        <div className="row">
          <div className="col-lg-12">
            <div className="svfeatures-content">
              <div className="c-container-pic">

                <div className="c-container-cabinet col-lg-3">
                  <div className="c-box-shelf">
                    <div className=" c-box-pic">
                      <div style={{
                        backgroundImage: "http://localhost:8086/images/soj2.jpg"
                      }} className="svfeatures-item first-feature wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div className="first-number number">
                          <h6 style={{ visibility: "hidden" }}>Fly For $673</h6>
                        </div>
                        <div className="icon"></div>
                        <h4 className="c-box-pic-text"><SVAButton style={{ fontSize: '12px', padding: '5px', color: '#ffffff', backgroundColor: '#ee2e2ef2' }} type="primary" shape="round" size="{size}" >Fly To Delhi </SVAButton></h4>
                        <div className="line-dec"></div>
                        <p style={{ height: "200px" }}>
                        </p>
                      </div>
                    </div>


                  </div>
                  <div className='c-box-shelf'>

                    <div className="box-promo-outer">
                      <span className="t-left">
                        <p className="sd-check" className="txt-price-type" ><text>Online Price </text></p>

                      </span>
                      <span className="t-right">

                        <p className="sd-check" className="txt-price-val"><text> Price $430 </text></p>
                      </span>

                    </div>
                  </div>



                </div>


                <div className="c-container-cabinet col-lg-3">
                  <div className="c-box-shelf">
                    <div className=" c-box-pic">
                      <div style={{
                        backgroundImage: "./images/soj3.jpg"
                      }} className="svfeatures-item first-feature wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                        <div class="first-number number">
                          <h6>01</h6>
                        </div>
                        <div className="icon"></div>
                        <h4>Fly To Delhi</h4>
                        <div className="line-dec"></div>
                        <p style={{ height: "200px" }}>
                        </p>
                      </div>
                    </div>

                    <div className="">
                      <p> I am shelf
                        <text> Price $630</text>
                      </p>
                    </div>
                  </div>

                </div>







              </div>
            </div>
          </div>

        </div>

      </div>
    )

  }

  getChildContainers_bad() {
    const l = 'http://localhost:8086/images'
    const l2 = 'http://localhost:8086/images/soj3.jpg'
    return (

      <div id="features" class="features section">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="features-content">
                <div class="row">
                  <div class="col-lg-3">
                    <div class="features-item first-feature wow fadeInUp" data-wow-duration="1s" data-wow-delay="0s">
                      <div class="first-number number">
                        <h6>01</h6>
                      </div>
                      <div class="icon"></div>
                      <h4>Reach Out</h4>
                      <div class="line-dec"></div>
                      <p><figure>
                        <img src={l} alt="Bluegrass" />

                      </figure>
                      </p>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <figure class="svfeatures-item second-feature wow fadeInUp" >
                      <img style={{ height: "400px", width: "100%" }} src={l2} alt="Bluegrass" />

                    </figure>


                  </div>
                  <div class="col-lg-3">
                    <div class="features-item first-feature wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.4s">
                      <div class="third-number number">
                        <h6>03</h6>
                      </div>
                      <div class="icon"></div>
                      <h4>Implementation</h4>
                      <div class="line-dec"></div>
                      <p>Our team will implement and you can view them in real time. Monitor and use features, improv</p>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="features-item second-feature last-features-item wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.6s">
                      <div class="fourth-number number">
                        <h6>04</h6>
                      </div>
                      <div class="icon"></div>
                      <h4>Analyze</h4>
                      <div class="line-dec"></div>
                      <p>Analyze the results and view them in real time. Monitor and use features, improvise revenues</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-12">
              <div class="skills-content">
                <div class="row">
                  <div class="col-lg-3">
                    <div class="skill-item wow fadeIn" data-wow-duration="1s" data-wow-delay="0s">
                      <div class="progress" data-percentage="80">
                        <span class="progress-left">
                          <span class="progress-bar"></span>
                        </span>
                        <span class="progress-right">
                          <span class="progress-bar"></span>
                        </span>
                        <div class="progress-value">
                          <div>
                            80%<br />
                            <span>HTML/CSS/JS</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="skill-item wow fadeIn" data-wow-duration="1s" data-wow-delay="0.2s">
                      <div class="progress" data-percentage="60">
                        <span class="progress-left">
                          <span class="progress-bar"></span>
                        </span>
                        <span class="progress-right">
                          <span class="progress-bar"></span>
                        </span>
                        <div class="progress-value">
                          <div>
                            60%<br />
                            <span>Wordpress</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="skill-item wow fadeIn" data-wow-duration="1s" data-wow-delay="0.4s">
                      <div class="progress" data-percentage="90">
                        <span class="progress-left">
                          <span class="progress-bar"></span>
                        </span>
                        <span class="progress-right">
                          <span class="progress-bar"></span>
                        </span>
                        <div class="progress-value">
                          <div>
                            90%<br />
                            <span>Marketing</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3">
                    <div class="skill-item last-skill-item wow fadeIn" data-wow-duration="1s" data-wow-delay="0.6s">
                      <div class="progress" data-percentage="70">
                        <span class="progress-left">
                          <span class="progress-bar"></span>
                        </span>
                        <span class="progress-right">
                          <span class="progress-bar"></span>
                        </span>
                        <div class="progress-value">
                          <div>
                            70%<br />
                            <span>Photoshop</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )

  }
  getChildContainers_old() {
    const CDN_URL = 'http://localhost:8086/images'
    let svr_tablets_prod = ['https://svamcos.svrenaissance.org/images/soj2.jpg', 'https://svamcos.svrenaissance.org/images/soj3.jpg', 'https://svamcos.svrenaissance.org/images/soj4.jpg', 'https://svamcos.svrenaissance.org/images/soj5.jpg', 'https://svamcos.svrenaissance.org/images/soj6.jpg']
    let svr_tablets = [`${CDN_URL}/soj2.jpg`, `${CDN_URL}/soj3.jpg`, `${CDN_URL}/soj4.jpg`, `${CDN_URL}/soj5.jpg`, `${CDN_URL}/soj6.jpg`]


    return (
      <div className="svr-gal-contentWrapper" >
        <h3> City Gallery View</h3>
        <p> Show tablets</p>

        <TerrainGallery tablets={svr_tablets}></TerrainGallery>

      </div>
    )
  }
  getCgBody_old() {
    const lastestUpdateDate = 'Data Refresh Daily'
    return (





      <GlassTerrain lastestUpdateDate={lastestUpdateDate} body={this.getChildContainers()}></GlassTerrain>

    )
  }
  getCgBody() {
    const lastestUpdateDate = 'Data Refresh Daily'
    return this.getChildContainers()
  }
  getCgBodyR1() {
    const lastestUpdateDate = 'Data Refresh Daily'
    return this.getChildContainersR1()
  }
  getCgBodyCruise() {
    const lastestUpdateDate = 'Data Refresh Daily'
    return this.getChildContainersCruise()
  }
  render() {

    console.log('svrender', this.props)
    const { my_data } = this.props

    return (
      <noop>
         <div className="col-md-12">
          {
            this.getCgBodyCruise(my_data)
          }


        </div>
        <div className="col-md-12">
          {
            this.getCgBodyR1(my_data)
          }



        </div>
        <div className="col-md-12">
          {
            this.getCgBody(my_data)
          }


        </div>
       
      </noop>
    )

  }
}

export default CityTerrainContainer